import React from 'react';

const CopyButton = ({ text, customButton: CustomButton }) => {
  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  };

  const handleClick = cb => {
    copyToClipboard();
    cb();
  };

  return CustomButton ? (
    <CustomButton triggerCopy={handleClick} />
  ) : (
    <button onClick={handleClick} className="ellington-copy-button">
      Copy
    </button>
  );
};

export default CopyButton;
